import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { HistoryRouter } from 'redux-first-history/rr6'
import { GoogleOAuthProvider } from '@react-oauth/google'
import App from './App/App'

import * as serviceWorker from './serviceWorker'
import { history, store } from './store'
import { GOOGLE_CLIENT_ID } from './constants'

import 'react-tippy/dist/tippy.css'
import './index.scss'

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <HistoryRouter history={history}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    </HistoryRouter>
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
